import type { ChatRestResponse } from './shared-types'

function responseFrom(data: Record<string, unknown>): ChatRestResponse {
  return {
    conversationId: (data['conversationId'] as string) || '',
    message: {
      role: 'assistant',
      content: (data['content'] as string) || '',
      timestamp: new Date().toISOString(),
    },
    toolCalls: Array.isArray(data['toolsUsed'])
      ? (data['toolsUsed'] as string[]).map((name) => ({
          name,
          result: null as unknown,
          status: 'approved' as const,
        }))
      : undefined,
    webSearch: data['webSearch'] as ChatRestResponse['webSearch'],
  }
}

/** Each legacy receipt owns only its initiating socket and timer. */
export function awaitSocketReceipt(
  socket: WebSocket,
  ownsSubject: () => boolean,
  send: () => boolean,
): Promise<ChatRestResponse> {
  return new Promise((resolve, reject) => {
    let settled = false
    const finish = (response?: ChatRestResponse, error?: Error) => {
      if (settled) return
      settled = true
      clearTimeout(timer)
      socket.removeEventListener('message', handler)
      socket.removeEventListener('close', closed)
      if (error) reject(error)
      else if (response) resolve(response)
    }
    const closed = () => finish(undefined, new Error('WebSocket não está aberto'))
    const handler = (event: MessageEvent) => {
      if (!ownsSubject()) {
        finish(undefined, new Error('Connection identity changed'))
        return
      }
      let parsed: unknown
      try {
        parsed = JSON.parse(event.data as string)
      } catch {
        return
      }
      if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return
      const data = parsed as Record<string, unknown>
      if (data['type'] === 'chat_response' || data['type'] === 'response')
        finish(responseFrom(data))
      if (data['type'] === 'error')
        finish(undefined, new Error((data['message'] as string) || 'Erro do engine'))
    }
    const timer = setTimeout(
      () => finish(undefined, new Error('Timeout aguardando resposta do engine')),
      180_000,
    )
    socket.addEventListener('message', handler)
    socket.addEventListener('close', closed)
    try {
      if (!ownsSubject() || !send()) finish(undefined, new Error('Connection identity changed'))
    } catch (error) {
      finish(undefined, error instanceof Error ? error : new Error('Connection identity changed'))
    }
  })
}
